import { useSeriesNav } from 'hooks/commonGame/useSeriesNav';
import { useFeatureFlags } from 'hooks/useFeatureFlags';

export const useEnableSeriesNavigationUpdate = () => {
  const seriesNav = useSeriesNav();
  const {
    // flag to control series-related navigation updates
    // but not restricted to simplified nav users (header, my cards changes, etc.)
    flags: { enableSeriesNavigationUpdate = false },
  } = useFeatureFlags();
  return seriesNav || enableSeriesNavigationUpdate;
};
